module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJldmVub2RkIj48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iPjxwYXRoIGQ9Ik0wIDdhNyA3IDAgMTExNCAwQTcgNyAwIDAxMCA3eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xMyA3QTYgNiAwIDEwMSA3YTYgNiAwIDAwMTIgMHoiIHN0eWxlPSJmaWxsOiB2YXIoLS1zdmctc3RhdHVzLWJnLCAjZmZmKTsiLz48L2c+PGNpcmNsZSBjeD0iNyIgY3k9IjciIHI9IjEiLz48Y2lyY2xlIGN4PSIxMCIgY3k9IjciIHI9IjEiLz48Y2lyY2xlIGN4PSI0IiBjeT0iNyIgcj0iMSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newImages/status__.svg
// module id = 1210
// module chunks = 173